module.exports = __webpack_public_path__ + "static/media/kids-after-mozart-in-shape.407ef365.jpg";